import * as ng from 'angular';
import * as _ from 'underscore';

import {GuestTypeService, GuestType} from '../guest-type';

const errorViewUrl = require('./error-view.html');

// should these perhaps be moved here rather than in asset dir?
require('file-loader?name=guestlist-template.csv!../../../asset/template/guestlist-template.csv');
require('file-loader?name=guestlist-template.xlsx!../../../asset/template/guestlist-template.xlsx');

export class ImporterController implements ng.IController {
   static $inject: string[] = [
      '$q',
      '$stateParams',
      'session',
      'utils',
      'loader',
      'ImporterService',
      'eventsApi',
      'surveyItemsApi',
      'GuestTypeService',
      '$uibModal',
      'toast',
      'titleService'
   ];

   constructor (
      private $q: ng.IQService,
      private $stateParams,
      private session,
      private utils,
      private loader,
      private ImporterService,
      private eventsApi,
      private surveyItemsApi,
      private guestTypeService:GuestTypeService,
      private $uibModal,
      private toast,
      private titleService
   ) {
      this.titleService.setTitle('Import ' + this.type.title);

      let promises = [
         this.surveyItemsApi.list(this.session.getBrand().id),
         this.guestTypeService.list(this.session.getCampaign().id)
      ];

      this.loader.showSpinner();
      this.$q.all<any>(promises).then((data) => {
         let surveys = data[0];
         let guestTypes = data[1] as GuestType[];

         for (let survey of surveys) {
            this.surveyData[survey.key.toLowerCase()] = survey;
         }

         this.guestTypes = _.pluck(guestTypes, 'name');

         this.loader.hide();
      });
   }

   finished = false;
   stage = 1;
   importer: any = {};
   eventLoading = false;
   formatError = null;

   file = null;
   type = this.ImporterService.getType(this.$stateParams.type);
   surveyData = {};
   event = null;
   timeslotId = null;
   guestTypes: string[];
   allowDupEmail = false;
   clearInvalidPhone = false;
   triggerDataEvents = false;

   setEvent(event: any) {
      this.event = null;
      this.timeslotId = null;

      if (event && event.id) {
         this.eventLoading = true;

         // get detailed event object so we have timeslots
         this.eventsApi.get(event.id).then((e) => {
            this.event = e;
         }).finally(() => {
            this.eventLoading = false;
         });
      }
   }

   getTimeSlotLabel(timeSlot: any): string {
      let label = '';
      if (timeSlot.name) {
         label += timeSlot.name + ' ';
      }
      label += this.utils.formatDate(timeSlot.startDateTime, 'M/D/YYYY - h:mma');
      return label;
   }

   parseFile() {
      this.ImporterService.readFile(this.file,
                                    this.type,
                                    this.surveyData,
                                    this.event,
                                    this.timeslotId,
                                    this.guestTypes,
                                    this.allowDupEmail,
                                    this.clearInvalidPhone).then((importerService) => {
         this.importer = importerService;
         this.formatError = importerService.formatError;
         if (!this.formatError) {
            this.stage++;
         } else {
            this.toast.error().message(this.getErrorMessage()).send();
         }
      }, (err) => {
         this.formatError = 'The file you uploaded did not contain properly formatted data, try our templates to ensure you have the correct format.';
         this.toast.error().message(this.getErrorMessage()).send();
      });
   }

   removeFile() {
      this.formatError = null;
      this.stage = 1;
      this.file = null;
      this.importer = null;
   }

   reset() {
      this.removeFile();
      this.event = null;
      this.timeslotId = null;
      this.allowDupEmail = false;
      this.clearInvalidPhone = false;
      this.triggerDataEvents = false;
      this.finished = false;
   }

   getErrorMessage(): string {
      if (this.stage == 2) {
         let hasCols = false;

         for (let value of this.importer.headers) {
            if (value.selected !== '') {
               hasCols = true;
               break;
            }
         }

         if (!hasCols) {
            return 'You must select at least one column to import';
         }
      }

      if (this.stage === 1 && !this.event) {
         return 'You must select an event to import into.';

      } else if (
         this.stage === 1 &&
         this.type.id == 'prereg' &&
         this.event.timeSlots &&
         this.event.timeSlots.length > 0 &&
         !this.timeslotId
      ) {
         return 'You must select a timeslot for the event to import into.';

      } else if (!this.file) {
         return 'You must select a valid file to import.';

      } else if (this.formatError) {
         return 'Please fix the formatting error in your spreadsheet.';

      } else if (this.stage === 2 && this.importer && this.importer.dataErrors) {
         return 'There are data errors, you must resolve them before continuing.';

      } else {
         return null;
      }
   }

   goNext() {
      let toastMessage = this.getErrorMessage();
      if (toastMessage) {
         this.toast.error().message(toastMessage).send();
      } else {
         if (this.stage === 1) {
            this.parseFile();
         }

         if (this.stage === 2) {
            this.stage++;
         }

         if (this.stage === 3) {
            this.doImport();
         }
      }
   }

   showErrors(header: any) {
      this.$uibModal.open({
         size: 'md',
         backdrop: 'static',
         templateUrl: errorViewUrl,
         controller: 'ImporterErrorController',
         resolve: {
            header: () => header
         }
      });
   }

   doImport() {
      this.importer.import(this.triggerDataEvents).then(() => {
         this.finished = true;
      }).catch((err) => {
         this.stage = 2;

         let message = 'There was an error importing your data, please contact support';
         if (err.data === 'Conflict') {
            message = 'Import could not complete due to conflicting wristband IDs';
         }

         this.toast.error().message(message).send();
      });
   }
}

ng.module('e360')
   .controller('ImporterController', ImporterController);
